import React from "react";
import { View, StyleSheet, TouchableOpacity, ActivityIndicator } from "react-native";
import { ArrowRightIcon } from "@phosphor-icons/react";

import { CourseDetailedAnalytics } from "@axio/graphql/generated/graphql";
import TableControlsContainer from "../../../../containers/general/TableControls/TableControlsContainer";
import CustomText from "../../../common/general/CustomText/CustomText";

interface CoursesListProps {
  coursesData: {
    data: CourseDetailedAnalytics[];
    count: number;
  } | null;
  onCourseSelect: (courseId: string) => void;
  isLoading: boolean;
  hasError: boolean;
  page: number;
  setPage: (page: number) => void;
  pageSize: number;
  setPageSize: (pageSize: number) => void;
}

const CoursesList: React.FC<CoursesListProps> = ({
  coursesData,
  onCourseSelect,
  isLoading,
  hasError,
  page,
  setPage,
  pageSize,
  setPageSize,
}) => {
  if (hasError) {
    return (
      <View style={styles.container}>
        <CustomText text="There was an error fetching the data. Please try again later." useTranslationText={false} />
      </View>
    );
  }

  if (isLoading) {
    return (
      <View style={styles.loaderContainer}>
        <ActivityIndicator size="large" color="#0000ff" />
      </View>
    );
  }

  return (
    <View style={styles.container}>
      {coursesData?.data?.map((course) => (
        <TouchableOpacity key={course.id} style={styles.courseCard} onPress={() => onCourseSelect(course.id)}>
          <CustomText text={course.label || "Unnamed Course"} weight="bold" useTranslationText={false} />
          <CustomText text={`Success Points: ${course.success_points || 0}`} size="s" useTranslationText={false} />
          <CustomText text={`Confusion Points: ${course.confusion_points || 0}`} size="s" useTranslationText={false} />
          <CustomText text={`Enrollment: ${course.enrollment || 0}`} size="s" useTranslationText={false} />
          <View style={styles.actionContainer}>
            <CustomText text="Tap to view details" size="xs" style={styles.actionText} />
            <ArrowRightIcon size={12} color="#0084FF" />
          </View>
        </TouchableOpacity>
      ))}
      {coursesData?.count > 0 && (
        <TableControlsContainer
          page={page}
          setPage={setPage}
          pageSize={pageSize}
          setPageSize={setPageSize}
          totalCount={coursesData?.count}
        />
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  loaderContainer: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    padding: 16,
  },
  container: {
    flex: 1,
  },
  courseCard: {
    padding: 16,
    backgroundColor: "#f8f9fa",
    borderRadius: 8,
    marginBottom: 8,
    borderWidth: 1,
    borderColor: "#e5e5e5",
    cursor: "pointer",
  },
  actionContainer: {
    flexDirection: "row",
    alignItems: "center",
    gap: 4,
  },
  actionText: {
    color: "#0084FF",
    fontStyle: "italic",
  },
});

export default CoursesList;
